import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Menu, Dropdown, Button, Modal, Checkbox, message } from "antd";
import { UserOutlined, DownOutlined, FormOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import router from "router";
import axios from "axios";
import { CANCEL_REQUEST } from "constants/index";
import { logout } from "redux/actions/auth.action";
import NoteService from "services/note.service";
import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

const { Header, Footer, Sider, Content } = Layout;

const ModalShare = ({ onClose, open = false, noteId }) => {
  const socket = useContext(SocketContext);
  const appContext = useContext(AppContext);
  const login = useSelector((state) => state.authReducer.user);
  const [usersData, setUsersData] = useState([]);
  const [noteUsersData, setNoteUsersData] = useState([]);

  useEffect(() => {
    socket.on("shared-note", (msg) => {
      message.success(msg);
      socket.emit("request-note-list");
    });
    if (noteId) {
      onSearch(noteId);
    }
  }, [open, noteId]);

  const onSearch = (id) => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    NoteService.getUsersByNoteId(id, source).then(
      (request) => {
        setUsersData(request.users);
        setNoteUsersData(request.note_users);
      },
      (error) => {
        if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        return Promise.reject();
      }
    );
  };

  const handleOk = () => {
    onClose(false);
  };

  const handleCancel = () => {
    onClose(false);
  };

  const onChange = (data, user_id) => {
    socket.emit("share-note", {
      status: data.target.checked,
      note_id: noteId,
      user_id: user_id,
    });
    onClose(false);
  };

  const NoteUser = (user, note_users) => {
    return (
      <p>
        <Checkbox
          checked={note_users.find((s) => s.user_id === user.id) ? true : false}
          disabled={user.username == login?.username ? true : false}
          onChange={(e) => onChange(e, user.id)}
        >
          {user.username}
        </Checkbox>
      </p>
    );
  };

  return (
    <Modal
      title="Share Note"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      {usersData ? (
        usersData.map((user) => NoteUser(user, noteUsersData))
      ) : (
        <p>No user...</p>
      )}
    </Modal>
  );
};

export default ModalShare;
